<template>
    <div class="card panel panel-default actions">
        <div class="card-block">
            <div class="header-block clearfix">
                <h3 class="pull-left">
                    {{ header }}
                </h3>
                <a v-if="canCreate" :href="createUrl">
                    <button class="btn btn-primary pull-right" type="button">
                        {{ createButtonText }}
                    </button>
                </a>
                <button v-if="createEvent" class="btn btn-primary pull-right" @click="event" type="button">
                    {{ createButtonText }}
                </button>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "pim-header",
        props: {
            canCreate: {
                type: Boolean,
                default: false,
            },
            createButtonText: {
                type: String,
                default: 'Create',
            },
            createUrl: {
                type: String,
                default: '',
            },
            createEvent: {
                type: Boolean,
                default: false
            },
            header: {
                type: String,
                required: true,
            },
        },
        methods: {
            event() {
                this.$emit('show-slot-content', true);
            }
        }
    }
</script>
